(function(){
  if (window.__nvPdp) return; window.__nvPdp = true;
  function money(cents, fmt){
    var v=(cents/100).toFixed(2);
    if(!fmt) return v;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if(k==='amount_with_comma_separator') return v.replace('.',',');
      if(k==='amount_no_decimals') return Math.round(cents/100).toString();
      if(k==='amount_no_decimals_with_comma_separator') return Math.round(cents/100).toString();
      return v;
    });
  }
  function initGallery(root){
    var slides=[].slice.call(root.querySelectorAll('.nv-gallery__slide'));
    var thumbs=[].slice.call(root.querySelectorAll('.nv-gallery__thumb'));
    if(!slides.length) return;
    var i=0;
    function go(n){
      i=(n+slides.length)%slides.length;
      slides.forEach(function(s,k){s.classList.toggle('is-active',k===i)});
      thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===i); if(k===i) t.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'})});
    }
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){go(k)})});
    var p=root.querySelector('.nv-gallery__nav--prev'), nx=root.querySelector('.nv-gallery__nav--next');
    p&&p.addEventListener('click',function(){go(i-1)}); nx&&nx.addEventListener('click',function(){go(i+1)});
    var main=root.querySelector('.nv-gallery__main'), x0=null;
    main.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    main.addEventListener('touchend',function(e){ if(x0===null) return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40) go(dx<0?i+1:i-1); x0=null;});
    root.addEventListener('nv:media',function(e){ var idx=slides.findIndex(function(s){return s.dataset.mediaId==String(e.detail)}); if(idx>-1) go(idx);});
  }
  function initBuy(root){
    var dataEl=root.querySelector('[data-nv-product]'); if(!dataEl) return;
    var data=JSON.parse(dataEl.textContent);
    var form=root.querySelector('form[data-nv-form]'); if(!form) return;
    var idInput=form.querySelector('input[name="id"]');
    var qtyInput=form.querySelector('input[name="quantity"]');
    var planInput=form.querySelector('input[name="selling_plan"]');
    var tiers=[].slice.call(root.querySelectorAll('.nv-tier'));
    var btn=form.querySelector('[data-nv-atc]');
    var btnLabel=btn.querySelector('span');
    function variant(){ return data.variants.find(function(v){return String(v.id)===String(idInput.value)}) || data.variants[0]; }
    function render(){
      var v=variant();
      tiers.forEach(function(t){
        var qty=parseInt(t.dataset.qty||'1',10), off=parseFloat(t.dataset.discount||'0');
        var plan=t.dataset.plan, price=v.price;
        if(plan){ var alloc=(v.plans||{})[plan]; if(alloc) price=alloc; }
        var total=Math.round(price*qty*(1-off/100));
        var full=(v.compare_at_price&&v.compare_at_price>v.price?v.compare_at_price:v.price)*qty;
        var pe=t.querySelector('[data-nv-price]'); if(pe) pe.textContent=money(total,data.fmt);
        var ce=t.querySelector('[data-nv-compare]'); if(ce){ ce.textContent= full>total?money(full,data.fmt):''; }
        var se=t.querySelector('[data-nv-per]'); var serv=parseInt(data.servings||0,10);
        if(se&&serv>0){ se.textContent=se.dataset.tpl.replace('[price]',money(Math.round(total/(serv*qty)),data.fmt)); }
      });
      var avail=v.available;
      btn.disabled=!avail; btnLabel.textContent= avail?btn.dataset.label:btn.dataset.soldout;
    }
    function select(t){
      tiers.forEach(function(x){x.classList.toggle('is-active',x===t); var r=x.querySelector('input'); if(r) r.checked=(x===t);});
      qtyInput.value=t.dataset.qty||1;
      if(planInput){ planInput.value=t.dataset.plan||''; planInput.disabled=!t.dataset.plan; }
    }
    tiers.forEach(function(t){ t.addEventListener('click',function(){select(t)}); t.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();select(t)}}); });
    var act=tiers.find(function(t){return t.classList.contains('is-active')})||tiers[0]; if(act) select(act);
    root.querySelectorAll('[data-nv-variant]').forEach(function(r){
      r.addEventListener('change',function(){
        idInput.value=r.value; render();
        var v=variant(); if(v.media_id){ var g=root.querySelector('.nv-gallery'); g&&g.dispatchEvent(new CustomEvent('nv:media',{detail:v.media_id})); }
        try{ var u=new URL(location.href); u.searchParams.set('variant',r.value); history.replaceState({},'',u);}catch(e){}
      });
    });
    render();
  }
  function init(scope){
    (scope||document).querySelectorAll('.nv-gallery').forEach(function(g){ if(!g.__nv){g.__nv=1;initGallery(g);} });
    (scope||document).querySelectorAll('.nv-hero').forEach(function(h){ if(!h.__nv){h.__nv=1;initBuy(h);} });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init()}); else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
